/**
 * Carrossel de vídeos da página Primeira Caixa: abre o vídeo escolhido em um <dialog> nativo.
 * O arquivo só é baixado ao tocar no cartão; ao fechar, o vídeo é pausado e descarregado.
 */
(() => {
  const iniciar = (secao) => {
    if (secao.dataset.pcvPronto) return;
    secao.dataset.pcvPronto = 'true';

    const lista = secao.querySelector('[data-pcv-lista]');
    const modal = secao.querySelector('[data-pcv-modal]');
    const video = secao.querySelector('[data-pcv-video]');
    if (!lista || !modal || !video) return;

    let origem = null;

    secao.addEventListener('click', (evento) => {
      const alvo = evento.target instanceof Element ? evento.target : null;
      if (!alvo) return;

      const abrir = alvo.closest('[data-pcv-abrir]');
      if (abrir) {
        origem = abrir;
        video.poster = abrir.dataset.poster || '';
        video.src = abrir.dataset.src || '';
        modal.showModal();
        video.play().catch(() => {});
        return;
      }

      if (alvo.closest('[data-pcv-fechar]') || alvo === modal) modal.close();

      const passo = lista.clientWidth * 0.8;
      if (alvo.closest('[data-pcv-prev]')) lista.scrollBy({ left: -passo });
      if (alvo.closest('[data-pcv-next]')) lista.scrollBy({ left: passo });
    });

    modal.addEventListener('close', () => {
      video.pause();
      video.removeAttribute('src');
      video.load();
      if (origem) origem.focus();
    });
  };

  const iniciarTodas = () => document.querySelectorAll('[data-pcv]').forEach(iniciar);
  iniciarTodas();
  document.addEventListener('shopify:section:load', iniciarTodas);
})();
